import { Link } from "react-router-dom";
import "../../style/scss/App.scss";
import { ImNewspaper } from "react-icons/im";

// import '../../style/selectionPanel.css';

export default function CareerListItem({career}) {
   return (
      <div className="Career mobilePanel">
         <Link to={"/careers/" + career.ID} className="centered skillLink">
            <span className="title">{career.Name}</span>
         </Link>

         <span className="byline">{career.Objective}</span>
         <span className="actionIcons">
            {career.Employments.length > 0 ? (
               <Link to={"/resume/" + career.ID} className="" title="View Resume">
                  <ImNewspaper size={1} color="red" />
               </Link>
            ) : (
               ""
            )}
         </span>
      </div>
   );
}


